<template>
	<div class="edit-manager-profile">
		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<h1 class="text-center sm:text-left">{{ $t('profile') }}</h1>
					<div class="row d-flex flex-col md:flex-row items-center sm:items-start mt-10 sm:mt-0">
						<ProfileImage
							v-model="profile.photo"
							@uploadPhoto="togglePhoto"
							class="mb-5 mr-0 sm:mr-8"
						/>
						<div class="vx-row justify-center sm:justify-start">
							<div class="vx-col w-full lg:w-2/3 xl:w-1/2 max-w-sm sm:max-w-full">
								<div class="vx-row items-end">
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('personName')" name="name" v-validate="'required|min:3'"
												  v-model="profile.first_name"/>
										<span
											:class="{ 'text-transparent': !errors.first('name')}"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vs-input label="Email" name="email" v-validate="'required|email|min:3'"
												  v-model="profile.email"/>
										<span
											:class="{ 'text-transparent': !errors.first('email')}"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('surname')" name="surname" v-validate="'required|min:3'"
												  v-model="profile.last_name"/>
										<span
											:class="{ 'text-transparent': !errors.first('surname')}"
											class="text-danger text-sm">
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>

									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vs-input :label="$t('emailForPayment')" name="emailRent"
												  v-validate="'required|email|min:3'"
												  v-model="profile.email_payment"/>
										<span
											:class="{ 'text-transparent': !errors.first('emailRent')}"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vx-input-group>
											<div class="vs-component vs-input vs-input-primary">
												<label class="vs-input--label">{{ $t('birthDate') }}</label>
												<div class="vs-con-input">
												</div>
												<vs-datepicker
													v-model="profile.birth_date"
													format="dd.MM.yyyy"
													v-validate="'required'"
													name="date"
												></vs-datepicker>
											</div>
											<span
												:class="{ 'text-transparent': !errors.first('date')}"
												class="text-danger text-sm"
											>
												{{ $t('fieldFilledIncorrect') }}
											</span>
										</vx-input-group>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<vs-phone
											:label="$t('phone')"
											name="phone"
											v-validate="'required|min:7|max:14'"
											v-model="profile.phone"
										/>
										<span
											:class="{ 'text-transparent': !errors.first('phone')}"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<div class="vs-component vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('sex') }}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												v-model="profile.gender === undefined ? 'undefined' : profile.gender"
												:reduce="country => country.id"
												label="name"
												v-validate="'required'"
												name="sex"
												:options="genders"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:clearable="false"
												class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('sex') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full sm:w-1/2 mb-2">
										<div class="vs-component vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('country')}}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												v-model="profile.country"
												:reduce="country => country.id"
												label="name"
												v-validate="'required'"
												name="sex"
												:options="countries"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												:clearable="false"
												class="single-row-select"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('country') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-full mb-2">
										<div class="vs-component vs-input vs-input-primary">
											<label class="vs-input--label">{{ $t('language')}}</label>
											<div class="vs-con-input">
											</div>
											<v-select
												v-model="profile.languages"
												v-validate="'required'"
												:closeOnSelect="false"
												:reduce="country => country.id"
												:options="languages"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
												multiple
												name="lang"
												data
												label="name"
											/>
										</div>
										<span
											:class="{ 'text-transparent': !errors.first('lang') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
								</div>
							</div>
							<div class="vx-col w-full lg:w-1/3 xl:w-1/2 max-w-sm sm:max-w-full">
								<div class="vx-row">
									<div class="vx-col w-full sm:w-1/2 lg:w-full xl:w-1/2 mb-2">
										<vx-input-group>
											<vs-password
												:label="$t('password')"
												data-vv-validate-on="blur"
												v-validate="'min:6|max:32'"
												type="password"
												ref="oldpassword"
												name="oldpassword"
												toggleCommand="oldpassword"
												@toggleShow="toggleShow"
												v-model="oldpassword"/>
										</vx-input-group>
										<span
											:class="{ 'text-transparent': !errors.first('oldpassword') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
									<div class="vx-col w-1/2 hidden xl:block"></div>
									<div class="vx-col w-full sm:w-1/2 lg:w-full xl:w-1/2">
										<vx-input-group>
											<vs-password
												:label="$t('repeatPassword')"
												data-vv-validate-on="blur"
												v-validate="'min:6|max:32'"
												type="password"
												ref="newpassword"
												name="newpassword"
												toggleCommand="newpassword"
												@toggleShow="toggleShow"
												v-model="newpassword"/>
										</vx-input-group>
										<span
											:class="{ 'text-transparent': !errors.first('newpassword') }"
											class="text-danger text-sm"
										>
											{{ $t('fieldFilledIncorrect') }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button class="mr-5" @click="editAuthor">
							{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="$router.go(-1)">
							{{ $t("cancel") }}
						</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import ProfileImage from "@/components/ProfileImage";
import vSelect from 'vue-select'
import datepicker from 'vuejs-datepicker'
import VsPassword from "@/components/vs-password/VsPassword";
import notifier from '../../mixins/notifier';

export default {
	name: "EditAuthor",
	mixins: [notifier],
	components: {
		ProfileImage,
		VsPassword,
		datepicker,
		'v-select': vSelect,
	},
	methods: {
		async togglePhoto(err,file){
			try {
				this.profile.photo = (await this.$http.post('/upload/one', this.$formData({file: file[0]}))).data.data.url;

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async editAuthor(){
			try {
				let formData = Object.assign({}, this.profile);

				if(this.newpassword !== '' && this.newpassword !== null) {
					formData.password = this.newpassword;
				}
				if(this.oldpassword !== '' && this.oldpassword !== null) {
					formData.password2 = this.oldpassword;
				}

				this.newpassword = null;
				this.oldpassword = null;

				let res = (await this.$http.post('/manager/profile/update',this.$formData(formData))).data.data;

				this.notifySuccess(this.$t('dataIsSaved'));

				await this.$store.dispatch("updateUserInfo", res);
				this.$router.back();

			}catch (e) {
				this.notifyError(e.message);
				if(e.errors){
					Object.values(e.errors).forEach(err=>{
						this.notifyError(err);
					})
				}
			}
		},
		async removePhoto(){
			try {
				let res = await this.$http.post('/manager/profile/delete-photo');

				this.notifySuccess(this.$t('dataIsSaved'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		toggleShow(ref) {
			let input = this.$refs[ref].$el.querySelector('input');
			input.type = input.type === 'password' ? 'text' : 'password';
		}
	},
	async created () {
		this.profile = 	 (await this.$http.get('/manager/profile')).data.data;
		this.languages = (await this.$http.get('/settings/get-languages')).data.data;
		this.subjects =  (await this.$http.get('/settings/get-subjects')).data.data;
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.genders =	 (await this.$http.get('/settings/get-genders')).data.data;

		if(this.profile.gender === 0) {
			this.profile.gender = 1
			this.$nextTick(() => this.profile.gender = 0)
		}
	},
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			name: '',
			email: '',
			email_payment: '',
			surname: '',
			date: '',
			phone: '',
			sex: '',
			country: '',
			about: '',
			oldpassword: '',
			newpassword: '',
			lang: [],
			subject: [],

			languages: [],
			subjects: [],
			countries: [],
			genders: [],
			profile: { gender: '' },
		}
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.vs-textarea {
	height: 110px;
}


.edit-manager-profile {
	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}


	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}

		}
	}

	.info {
		width: 200px;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}

	.vs-con-input-label {
		width: initial;
	}
}
</style>
